/*
  Pacific Formulations — smooth scrolling (Lenis)

  Eases the page toward where the wheel sent it rather than jumping there.
  It moves the REAL scroll position, so everything that reads scroll — the
  reveal observers, the card deck, the sticky header, anchor links — keeps
  working unchanged.

  Loaded by layout/theme.liquid only when the "Smooth scrolling" theme setting
  is on, after assets/lenis.min.js. The glide length comes from that setting
  via window.__pfScroll.

  Deliberately off when:
    - the visitor prefers reduced motion (never constructed at all)
    - the input is touch (syncTouch: false — phones keep native scrolling)
    - the session has been opted out with ?lenis=0 (opt back in with ?lenis=1),
      which is what lets the setting be judged on and off without a redeploy

  Paused, not off, while anything locks the page — the cart drawer, the
  quick-add modal. Dawn marks those states by putting `overflow-hidden` on
  <body>. Without pausing, a wheel over the drawer's scrim would move the page
  behind it, because Lenis scrolls the window programmatically and
  overflow: hidden only stops the user, not scrollTo(). The inner lists of the
  drawer and the modal are also marked data-lenis-prevent so their own
  scrolling stays native when they overflow.
*/
(() => {
  const q = new URLSearchParams(location.search);
  if (q.get('lenis') === '0') sessionStorage.setItem('pf-lenis-off', '1');
  if (q.get('lenis') === '1') sessionStorage.removeItem('pf-lenis-off');
  if (sessionStorage.getItem('pf-lenis-off') === '1') return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (typeof window.Lenis !== 'function') return;

  document
    .querySelectorAll('.drawer__contents, .quick-add-modal__content')
    .forEach((el) => el.setAttribute('data-lenis-prevent', ''));

  const cfg = window.__pfScroll || {};
  const lenis = new window.Lenis({
    lerp: Number(cfg.lerp) || 0.14,
    // Just under native distance per wheel click. This was judged together
    // with the 0.14 glide; changing one without the other changes the feel.
    wheelMultiplier: 0.9,
    syncTouch: false,
  });
  window.pfLenis = lenis;

  const raf = (time) => {
    lenis.raf(time);
    requestAnimationFrame(raf);
  };
  requestAnimationFrame(raf);

  const sync = () => {
    if (document.body.classList.contains('overflow-hidden')) lenis.stop();
    else lenis.start();
  };
  new MutationObserver(sync).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  sync();
})();
